import {vnModule_knockoutJS} from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import {XMLHttpRequestHandler} from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import {header} from "./header";
import {brandDashboard_template} from "../components/templates/brandDashboard_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnAppZone } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone';

declare var ko: any;
declare var page: any;

export class brandDashboard extends vnModule_knockoutJS{

    protected brandDashboard_template: brandDashboard_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected zoneHeader: vnAppZone | null;

    /**
     * @inheritDoc
     */
    protected getModuleName(): string{

        return 'brandDashboard';
    }


    /**
     * @inheritDoc
     */
    public buildContent() : Array<Element>{

        this.zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = this.zoneHeader?.loadedModule;
        (<header>loadedModule).setHeaderTitle('Brand Dashboard');

        this.brandDashboard_template = new brandDashboard_template('brandDashboard', this.viewModel, this)
        this.template = this.brandDashboard_template;

        return [this.brandDashboard_template.build()];
    }

    /**
     * @inheritDoc
     */
    public fillPage(): void{

        this.brandDashboard_template.buildDatePickerCalendar();
        this.brandDashboard_template.setMetricFilterItems();
        this.brandDashboard_template.setDimensionFilterItems();

        // First get the presets
        this.getSearchPresetsListData();
    }

    protected getListFormData(): void{

        //this.loadingIn(this.brandDashboard_template.builtTemplate.querySelector("#report-results"));

        let subViewModel = this.brandDashboard_template.getViewModelForRequest();

        let usrReq_url: string = '/api/brand_dashboard/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

        /**
     * Returns handler for filter request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected onFilterRequestReturn(req, obj): Function{

        return function(){

            if(req.request.readyState == 4){
                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);

                    // Every 100 report loads, display the Plan upgrade promotion (to free plan accounts only)
                    obj.zoneHeader?.loadedModule.showPlanPromo();

                    obj.updateFilters(responseParsed);
                    
                    obj.updateViewModelFromPath();
                    
                    obj.getReportData();

                    // LOADING : ends
                }
            }

            obj.loadingOut(obj.brandDashboard_template.builtTemplate.querySelector("#report-results"));
        }
    }

    /**
     * Update the filters.
     *
     * @param responseParsed
     */
    protected updateFilters(responseParsed: any): void{

        this.brandDashboard_template.setBrandFilterItems(responseParsed.portfolios);
    }

    public getReportData(): void{

        let subViewModel = this.brandDashboard_template.getViewModelForRequest();
        let baseApiUrl = '/api/brand_dashboard/get/';

        let dataCalls: string[] = ['overview', 'device', 'os', 'browser', 'geo', 'source', 'landingPage'];

        dataCalls.forEach( (dataCall) => {

            subViewModel['dataCall'] = dataCall;

            let loadItem = this.brandDashboard_template.builtTemplate.querySelector(".section-"  +  dataCall);
            this.loadingIn(loadItem);

            this.sendFilterCall(baseApiUrl, subViewModel, this.getReportDataRequestReturn.bind(this, dataCall, loadItem), XMLHttpRequestHandler_requestType.GET, 'getReportData' + dataCall);
        });
    }


    /**
     * Returns handler for data request.
     *
     * @param req
     * @param obj
     *
     * @return {function(): void}
     */
    protected getReportDataRequestReturn(dataCall, loadItem, req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateData(dataCall, responseParsed.data);
            });

            obj.loadingOut(loadItem);
        }
    }

    protected updateData(dataCall, responseParsed: any): void{

        this.brandDashboard_template.updateData(dataCall, responseParsed);
    }

     /**
     * Hook.
     *
     * Initiates data refresh.
     */
     public filterDropdownOnChange(element): void{

        if(element=='brandFilter'){

            this.getReportData();
        }
     }

    protected filterDateOnChange(element) {

        this.brandDashboard_template.setMobileDateBtnSwitch('other');
        this.getReportData();
    }

    protected filterSingleGroupSelectorOnChange(element){

        if (element=='dimensionFilter') {

            this.brandDashboard_template.onDimensionSwitch();
        }else {

            if (element=='metricFilter') {

                this.brandDashboard_template.onMetricSwitch();
            }

            this.getReportData();
        }
    }

    /**
     * Hook.
     *
     * Cancels data request.
     */
    protected filterSimpleCancel(){

        if(this.XHRHdl){

            this.XHRHdl.cancelAndReset();
        }
    }

    public onQuit(){

        for(let callKey in this.XHRHdls){

            this.XHRHdls[callKey].cancelAndReset();
        }
    }

    private getXHRHdl(baseURl, callIdentifier){

        let callKey =   baseURl + '-' + callIdentifier;

        return this.XHRHdls[callKey];
    }
}


// WEBPACK FOOTER //
// ./js/modules/brandDashboard.ts